import React from 'react'
import "./Blog.css"
export default function Blog() {
    return (
        <div>
            <div class="blog_post">
                <div class="container_copy">
                    <h3 className='sentense'>Visit our blog for more</h3>
                    <a class="btn_primary" href='https://fideliswaweru.netlify.app/' target="_blank">Blog</a>
                </div>

            </div>
        </div>
    )
}
